import { Paragraph } from "@digdir/designsystemet-react";
import { ChevronLeftIcon } from "@navikt/aksel-icons";
import { Link } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export function Page({
  children,
  className,
  withBackLink = false,
  withoutPadding = false,
}: PropsWithChildren<{
  className?: string;
  withBackLink?: boolean;
  withoutPadding?: boolean;
}>) {
  return (
    <article
      className={cn(
        "w-full space-y-4 my-12 pb-12 px-5 max-w-page sm:px-15",
        "bg-balder-background-default",
        withBackLink ? "" : "",
        withoutPadding ? "" : "mx-auto",
        className,
      )}
    >
      {withBackLink && <BackLink />}
      {children}
    </article>
  );
}

function BackLink() {
  const { t } = useTranslation();
  return (
    <section className="pb-6">
      <Paragraph data-size="md" asChild>
        <Link to="/" className="text-inherit flex items-center gap-2">
          <ChevronLeftIcon fontSize="2rem" />
          <span>{t("button.back-to-frontpage")}</span>
        </Link>
      </Paragraph>
    </section>
  );
}
